// import NavBarInGame from '../components/NavBarInGame'
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import cst from '../assets/cst.png'

import select3x3 from '../assets/select3x3.png'
import select4x4 from '../assets/select4x4.png'
import select5x5 from '../assets/select5x5.png'

import sliding3x3 from '../assets/sliding3x3.png'
import sliding4x4 from '../assets/sliding4x4.png'

import memoryLev1 from '../assets/memoryLev1.png'
import memoryLev2 from '../assets/memoryLev2.png'

import lowerCaseImg from '../assets/alphabetGameImages/lowerCaseImg.png'
import UpperCaseImg from '../assets/alphabetGameImages/upperCaseImg.png'

import fillAlphabets from '../assets/alphabetGameImages/fillAlphabets.png'
import fillNumbers from '../assets/fillNumbers.png'

export default function Example() {
    
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
      };
  return (
    <>
        {/* <NavBarInGame/> */}
        <div className="flex flex-col lg:grid grid-cols-2 justify-start items-center m-2 border-[1px] border-[#112244] pb-4">
            <div className="flex flex-col justify-start items-center m-2 border-[1px] border-[#112244] pb-4">
                <h1 className='text-[#ffffff] text-3xl font-bold p-2'>
                    Select Number Game
                </h1>
                <div className='ml-8 mr-8 w-[300px] md:w-[600px]'>
                    <Slider {...settings}>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={select3x3} alt="" />
                            <div className='flex'>
                                <Link className='basis-1/2 p-1' to="/3x3select/normal">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Practice
                                    </button>
                                </Link>
                                <Link className='basis-1/2 p-1' to="/3x3select/hard">
                                    <button className='w-full bg-[#FFC700] rounded p-2 text-[#FF0000] text-2xl font-bold'>
                                        Test
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={select4x4} alt="" />
                            <div className='flex'>
                                <Link className='basis-1/2 p-1' to="/4x4select/normal">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Practice
                                    </button>
                                </Link>
                                <Link className='basis-1/2 p-1' to="/4x4select/hard">
                                    <button className='w-full bg-[#FFC700] rounded p-2 text-[#FF0000] text-2xl font-bold'>
                                        Test
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={select5x5} alt="" />
                            <div className='flex'>
                                <Link className='basis-1/2 p-1' to="/5x5select/normal">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Practice
                                    </button>
                                </Link>
                                <Link className='basis-1/2 p-1' to="/5x5select/hard">
                                    <button className='w-full bg-[#FFC700] rounded p-2 text-[#FF0000] text-2xl font-bold'>
                                        Test
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>


            
            <div className="flex flex-col justify-start items-center m-2 border-[1px] border-[#112244] pb-4">
                <h1 className='text-[#ffffff] text-3xl font-bold p-2'>
                    Sliding Number Game
                </h1>
                <div className='ml-8 mr-8 w-[300px] md:w-[600px]'>
                    <Slider {...settings}>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={sliding3x3} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/slidingwindow3x3">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={sliding4x4} alt="" />
                            <div className='flex'>
                            <Link className='w-full p-1' to="/slidingwindow4x4">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>



            <div className="flex flex-col justify-start items-center m-2 border-[1px] border-[#112244] pb-4">
                <h1 className='text-[#ffffff] text-3xl font-bold p-2'>
                    Memory Game
                </h1>
                <div className='ml-8 mr-8 w-[300px] md:w-[600px]'>
                    <Slider {...settings}>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={memoryLev1} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/memorygame1">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={memoryLev2} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/memorygame2">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>



            <div className="flex flex-col justify-start items-center m-2 border-[1px] border-[#112244] pb-4">
                <h1 className='text-[#ffffff] text-3xl font-bold p-2'>
                    Select Alphabet Game
                </h1>
                <div className='ml-8 mr-8 w-[300px] md:w-[600px]'>
                    <Slider {...settings}>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={lowerCaseImg} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/selectAlphabetsLowerCase">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={UpperCaseImg} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/selectAlphabetsUpperCase">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>



            <div className="flex flex-col justify-start items-center m-2 border-[1px] border-[#112244] pb-4">
                <h1 className='text-[#ffffff] text-3xl font-bold p-2'>
                    Fill-In-The-Blanks Game 
                </h1>
                <div className='ml-8 mr-8 w-[300px] md:w-[600px]'>
                    <Slider {...settings}>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={fillAlphabets} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/alphabetFill">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img className='w-[300px] md:w-[600px] border-[1px] border-[#112244]' src={fillNumbers} alt="" />
                            <div className='flex'>
                                <Link className='w-full p-1' to="/numbersFill">
                                    <button className='w-full bg-[#1C4D08] rounded p-2 text-[#7ED957] text-2xl font-bold'>
                                        Play
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
    </>
  );
}
